"use client";

import { EventDetails } from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";
import {
  faCalendar,
  faDoorOpen,
  faPerson,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { localTimeToDayjs } from "~/lib/utils";
import { Translations } from "~/lib/definitions";
import { isAzetShop } from "~/lib/client/isAzetShop";
import { PlainMessage } from "@bufbuild/protobuf";

type Props = {
  eventDetails: PlainMessage<EventDetails>;
  translations: Translations;
};

export default function Details({ eventDetails, translations }: Props) {
  const start = localTimeToDayjs(eventDetails.event?.start);
  const end = localTimeToDayjs(eventDetails.event?.end);
  const doorsOpen = localTimeToDayjs(eventDetails.doorsOpen);
  const isAzet = isAzetShop();

  return (
    <>
      <div className="flex gap-3">
        <div className="flex flex-row items-center justify-center rounded-lg bg-gray-200 p-2">
          <FontAwesomeIcon className="text-link" icon={faCalendar} />
        </div>
        <p>
          {start.format("DD.MM.YYYY HH:mm")} {translations.clock}
          {!isAzet && (
            <>
              {" - "}
              {end.format("DD.MM.YYYY HH:mm")} {translations.clock}
            </>
          )}
        </p>
      </div>
      {!isAzet && (
        <div className="flex gap-3">
          <div className="flex flex-row items-center justify-center rounded-lg bg-gray-200 p-2">
            <FontAwesomeIcon className="text-link" icon={faDoorOpen} />
          </div>
          <p>
            {doorsOpen.format("DD.MM.YYYY HH:mm")} {translations.clock}
          </p>
        </div>
      )}
      {eventDetails?.event?.promoter !== undefined &&
        eventDetails.event.promoter.length > 0 && (
          <div className="flex gap-3">
            <div className="flex flex-row items-center justify-center rounded-lg bg-gray-200 p-2">
              <FontAwesomeIcon className="text-link" icon={faPerson} />
            </div>
            <div className="flex flex-col">
              <p>{eventDetails.event?.promoter}</p>
            </div>
          </div>
        )}
    </>
  );
}
